<template>

    <v-page-body>

        <v-page-section padded>
            <template #title>Installation Methods</template>
            <template #body>
                <div class="intro">
                    <p>Ready to get started? CrowdPower needs to know a little about your customers to monitor user activity and run automations. To do that, you can install our JavaScript Tag or ping our Beacon API. You may also connect with services you already use.</p>
                </div>
                <div class="d-flex align-items-start">
                    <div class="tiles">
                        <div class="tile suggested" @click="open('https://docs.crowdpower.io/getting-started/javascript-tag')">
                            <v-ribbon label="Suggested" />
                            <span>JavaScript Tag<br><span class="small">Send data from your website</span></span>
                        </div>
                        <div class="tile suggested" @click="open('https://docs.crowdpower.io/getting-started/beacon-api')">
                            <v-ribbon label="Suggested" />
                            <span>Beacon API<br><span class="small">Send data from your server</span></span>
                        </div>
                        <div class="tile" @click="$router.push({ name: 'install-segment' })">
                            <v-icon symbol="logo-segment" :width="200" :height="100" />
                        </div>
                        <div class="tile" @click="$router.push({ name: 'install-stripe' })">
                            <v-icon symbol="logo-stripe" :width="200" :height="100" />
                        </div>
                        <div class="tile" @click="open('https://zapier.com/apps/crowdpower/integrations')">
                            <v-icon symbol="logo-zapier" :width="200" :height="100" />
                        </div>
                        <div class="tile" @click="open('https://www.integromat.com/en/integrations/crowdpower')">
                            <v-icon symbol="logo-integromat" :width="200" :height="100" />
                        </div>
                        <div class="tile" @click="open('https://www.pabbly.com/connect/integrations/crowdpower-io/')">
                            <v-icon symbol="logo-pabbly" :width="200" :height="100" />
                        </div>
                    </div>
                    <v-checklist />
                </div>
            </template>
        </v-page-section>

        <img src="https://ct.capterra.com/capterra_tracker.gif?vid=2148223&vkey=1316129e71dbc240700ca10fe0c10935" />

    </v-page-body>

</template>

<style scoped lang="scss">

    .intro {
        margin: 0 auto 30px auto;
        max-width: 600px;
        text-align: center;
        p {
            @include font-medium(15px);
            line-height: 1.6em;
        }
        h3 {
            @include font-medium(30px);
            line-height: 1.6em;
        }
    }

    .tiles {
        display: grid;
        flex-grow: 1;
        grid-gap: 10px;
        grid-template-columns: 1fr 1fr;
        .tile {
            @include font-semibold(16px);
            border: 1px solid $color-rule;
            border-radius: 5px;
            color: $color-primary;
            cursor: pointer;
            display: grid;
            height: 160px;
            line-height: 1.6em;
            overflow: hidden;
            place-items: center;
            position: relative;
            text-align: center;
            text-decoration: none;
            transition: border-color .3s;
            &:hover {
                border-color: $color-text;
            }
            .small {
                @include font-medium(14px);
                color: $color-muted;
            }
        }
    }

</style>

<script>

import Checklist from './components/Checklist';

export default {

    components: {
        'v-checklist': Checklist,
    },

    mounted() {
        this.$events.$emit('pageLoaded');
    },

    methods: {

        open(url) {
            window.open(url, '_blank');
        },

    },

}

</script>